import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  SyncDataModalForSyncingContainer, type SyncDataModalForSyncingContainerProps,
} from './syncDataModalForSyncing.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SyncGoogleSheet: SyncDataModalForSyncingContainerProps;
  }
}

modalRenderer.register('SyncGoogleSheet', SyncDataModalForSyncingContainer);
